import React from "react";
import "./cardSection.css";
import { Card, Typography } from "antd";

// Define the props type
interface CardSectionProps {
  id: string | number;
  title: string;
  inputFields: React.ReactNode;
  subheader?: string;
}

const CardSection: React.FC<CardSectionProps> = (props) => {
  const { title, inputFields, subheader, id } = props;
  return (
    <div id={`card-section-${id}`} className="card-section">
      <div id={`card-content-${id}`} className="card-content">
        <Card title={title} variant="borderless">
          {subheader?.trim() ? (
            <Typography id={`card-subheader-${id}`} className="card-subheader">
              {subheader}
            </Typography>
          ) : null}
          {inputFields}
        </Card>
      </div>
    </div>
  );
};

export default CardSection;
